<template>
    <div class="uploadList" :class="`uploadList-${showType}`">
        <!-- 普通文本模式 -->
        <template v-if="showType ==='old'">
            <div v-if="files && files.length > 0" class="uploadList-list"  ref="viewerImage">
                <div
                    v-for="fileItem in files"
                    :key="fileItem.url"
                    class="uploadList-listItem"
                >
                    <!-- 展示图 -->
                    <div class="uploadList-listItem-show">
                        <img v-if="propsObj._fileType === 'image' || (fileItem.mimetype.indexOf('image') > -1)"
                            :data-original="fileItem.url"
                            :src="$imageResize(fileItem.url, imageResizeConfig)"
                            :alt="fileItem.name"
                        >
                        <img v-else
                            :src="getFileImage(fileItem)"
                            :alt="fileItem.name"
                        >
                    </div>

                    <!-- 展示名称 -->
                    <Ctooltip
                        class="uploadList-listItem-name"
                        :content="fileItem.name"
                        :transfer="true"
                        placement="top-start"
                        max-width="300"
                    >
                        <p class="uploadList-listItem-name-title">{{ fileItem.name }}</p>
                    </Ctooltip>

                    <!-- 图标 -->
                    <dsh-icons
                        class="uploadList-listItem-action"
                        item-class="uploadList-listItem-action-icon"
                        :list="$getOperationList(getBtns((fileItem.mimetype.indexOf('image') > -1) || (fileItem.mimetype.indexOf('application/pdf') > -1)))"
                        @click="$dispatchEvent($event,fileItem)"
                    ></dsh-icons>
                </div>
            </div>
            <div v-else class="uploadList-nodata">
                <Icon type="ios-time" />
                <span>未上传文件</span>
            </div>
        </template>
        <!-- 内部表格模式 -->
        <template v-else-if="showType==='new'">
            <dsh-dropdown
                class="uploadList-new-dropdown"
                placement="bottom"
                :list="files"
            >
                <!-- 显示  -->
                <div class="uploadList-new-show">
                    <span>
                        {{ files.length || "未上传文件" }}
                        {{ files.length ? (this.propsObj._fileType === "image" ? "张" : "个" ) : ""}}
                    </span>
                    <Icon type="ios-arrow-down" />
                </div>

                <div ref="viewerImage" slot="DropdownMenu">
                    <DropdownItem
                        v-for="dropdownItem in files"
                        :key="dropdownItem._id || dropdownItem.type"
                        :name="dropdownItem.name"
                        :disabled="dropdownItem.disabled"
                        :divided="dropdownItem.divided"
                        :selected="dropdownItem.selected"
                    >
                        <div class="uploadList-new-listItem">
                            <div class="uploadList-new-listItem-show">
                                <img v-if="propsObj._fileType === 'image' || (dropdownItem.mimetype.indexOf('image') > -1)"
                                    :data-original="dropdownItem.url"
                                    :src="$imageResize(dropdownItem.url, imageResizeConfig)"
                                    :alt="dropdownItem.name"
                                >
                                <img v-else
                                    :src="getFileImage(dropdownItem)"
                                    :alt="dropdownItem.name"
                                >
                            </div>

                            <div class="uploadList-new-listItem-right">
                                <!-- 展示名称 -->
                                <Ctooltip
                                    class="uploadList-new-listItem-name"
                                    :content="dropdownItem.name"
                                    :transfer="true"
                                    placement="top-start"
                                    max-width="300"
                                >
                                    <p class="uploadList-new-listItem-name-title">{{ dropdownItem.name }}</p>
                                </Ctooltip>

                                <!-- 图标 -->
                                <dsh-icons
                                    class="uploadList-new-listItem-action"
                                    item-class="uploadList-new-listItem-action-icon"
                                    :list="$getOperationList(getBtns((dropdownItem.mimetype.indexOf('image') > -1) || (dropdownItem.mimetype.indexOf('application/pdf') > -1)))"
                                    @click="$dispatchEvent($event,dropdownItem)"
                                ></dsh-icons>
                            </div>
                        </div>
                    </DropdownItem>
                    <DropdownItem v-if="!files.length">
                        <Icon type="ios-time" />
                        <span>未上传内容</span>
                    </DropdownItem>
                </div>
            </dsh-dropdown>
        </template>
        <!-- 自定义新的展示方式 -->
        <template v-else-if="showType === 'inline'">
            <div v-if="files && files.length > 0" class="uploadList-inline-list bri-scrollbar6"  ref="viewerImage">
                <div
                    class="uploadList-inline-listItem"
                    v-for="fileItem in files"
                    :key="fileItem.url"
                >
                    <img v-if="propsObj._fileType === 'image' || (fileItem.mimetype.indexOf('image') > -1)"
                        :data-original="fileItem.url"
                        :src="$imageResize(fileItem.url, imageResizeConfig)"
                        :alt="fileItem.name"
                    >
                    <img v-else
                        :src="getFileImage(fileItem)"
                        :alt="fileItem.name"
                    >
                   <dsh-icons
                        class="uploadList-inline-listItem-action"
                        item-class="uploadList-inline-listItem-action-icon"
                        :list="$getOperationList(getBtns((fileItem.mimetype.indexOf('image') > -1) || (fileItem.mimetype.indexOf('application/pdf') > -1)))"
                        @click="$dispatchEvent($event,fileItem)"
                    ></dsh-icons>
                </div>
            </div>
            <span v-else>未上传文件</span>
        </template>
    </div>
</template>
<script>
    import Viewer from "viewerjs";
    import axios from "axios";

    export default {
        name: "uploadList",
        props: {
            files: {
                type: Array,
                default () {
                    return [];
                }
            },
            showType: {
                type: String,
                default: "old" // new, old, normal
            },
            isReadonly: Boolean,
            isDisabled: Boolean,
            finalCanEdit: Boolean,
            propsObj: Object
        },
        computed: {
            operationMap () {
                return {
                    remove: {
                        name: "删除",
                        icon: "ios-trash-outline",
                        size: "16",
                        event: "handleRemove",
                        canShow: this.finalCanEdit
                    },
                    download: {
                        name: "下载",
                        icon: "ios-cloud-download-outline",
                        size: "14",
                        event: "handleDownload",
                        canShow: true
                    },
                    preview: {
                        name: "预览",
                        icon: "ios-eye-outline",
                        size: "22",
                        type: "updateColor",
                        event: "handlePreview",
                        canShow: undefined
                    }
                };
            },
            imageResizeConfig () {
                return {};
                // this.propsObj._imageResizeConfig || (this.showType == "new" ? {
                //     m: "lfit",
                //     w: 34,
                //     h: 37
                // } : {
                //     m: "lfit",
                //     w: 76,
                //     h: 50
                // });
            }
        },
        data () {
            return {
            };
        },
        methods: {
            getBtns (canPreview) {
                this.operationMap.preview.canShow = canPreview;
                return Object.keys(this.operationMap).filter(attr => this.operationMap[attr].canShow);
            },

            // 点击文件预览 -file服务器的数据列表
            handlePreview (operation, file) {
                if (this.propsObj._fileType === "image") {
                    this.previewImage(file.url);
                } else if (file.mimetype.indexOf("image") > -1) {
                    this.previewImage(file.url);
                } else {
                    window.open(file.url);
                }
                this.$emit("on-file-preview", file);
            },
            // 图片预览
            previewImage (src) {
                let viewerImage = this.$refs.viewerImage;
                let findIndex = this.files
                    .filter(valItem => valItem.mimetype.indexOf("image") > -1)
                    .findIndex(valItem => valItem.url === src);

                let viewer = new Viewer(viewerImage, {
                    url: "data-original",
                    hidden: function () {
                        viewer.destroy();
                    },
                    loop: false,
                    initialViewIndex: findIndex,
                    zIndex: 2147483647
                });
                viewer.show();
            },

            handleDownload (operation, file) {
                this.downloadFile(file.url, file);
            },
            downloadFile (url, file) {
                axios
                    .get(url, {
                        responseType: "blob"
                    })
                    .then((res) => {
                        if (window.navigator.msSaveOrOpenBlob) {
                            // 兼容IE10
                            navigator.msSaveBlob(res, file.name);
                        } else {
                            const href = URL.createObjectURL(res); // 创建新的URL表示指定的blob对象
                            const a = document.createElement("a");
                            a.style.display = "none";
                            a.href = href; // 指定下载链接
                            a.download = file.name; // 指定下载文件名
                            a.click();
                            URL.revokeObjectURL(a.href); // 释放URL对象
                            a.remove();
                        }
                });
            },
            handleRemove (operation, file) {
                this.$emit("on-file-remove", file);
            },
            format (file) {
                const format = file.name.split(".").pop().toLocaleLowerCase() || "";
                let type = "ios-document-outline";

                if (["gif", "jpg", "jpeg", "png", "bmp", "webp"].indexOf(format) > -1) {
                    type = "ios-image";
                }
                if (["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"].indexOf(format) > -1) {
                    type = "ios-film";
                }
                if (["mp3", "wav", "wma", "ogg", "aac", "flac"].indexOf(format) > -1) {
                    type = "ios-musical-notes";
                }
                if (["doc", "txt", "docx", "pages", "epub", "pdf"].indexOf(format) > -1) {
                    type = "md-document";
                }
                if (["numbers", "csv", "xls", "xlsx"].indexOf(format) > -1) {
                    type = "ios-stats";
                }
                if (["keynote", "ppt", "pptx"].indexOf(format) > -1) {
                    type = "ios-videocam";
                }

                return type;
            },
            // 获取不同类型文件的图片
            getFileImage (item) {
                if (!item.mimetype) {
                    return this.$imageSrcMap.fileType.other;
                } else if (item.mimetype.indexOf("image") > -1) {
                    return item.url; // 压缩图片：将图片最长的边限制在100像素，短边按比例处理
                } else if (item.mimetype.indexOf("text/plain") > -1) {
                    return this.$imageSrcMap.fileType.text;
                } else if (item.mimetype.indexOf("application/pdf") > -1) {
                    return this.$imageSrcMap.fileType.pdf;
                } else if (item.mimetype.indexOf("wordprocessingml.document") > -1 || item.mimetype.indexOf("application/msword") > -1) {
                    return this.$imageSrcMap.fileType.doc;
                } else if (item.mimetype.indexOf("presentationml.presentation") > -1 || item.mimetype.indexOf("application/vnd.ms-powerpoint") > -1) {
                    return this.$imageSrcMap.fileType.ppt;
                } else if (item.mimetype.indexOf("spreadsheetml.sheet") > -1) {
                    return this.$imageSrcMap.fileType.excel;
                } else if (item.mimetype.indexOf("application/x-zip-compressed") > -1) {
                    return this.$imageSrcMap.fileType.zip;
                } else if (item.mimetype.indexOf("application/x-rar-compressed") > -1) {
                    return this.$imageSrcMap.fileType.rar;
                } else {
                    return this.$imageSrcMap.fileType.other;
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/ZUpload/upload-list.vue